<template>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row m-0">
          <div class="col-12 p-0">
            <LightMap
              v-if="markers && markers.length"
              v-model:markers="markers"
              @on-minimize="closeModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LightMap from "../maps/maps/lightMap.vue";

export default {
  components: {
    LightMap,
  },
  data() {
    return {
      markers: [],
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    initializeModal(list) {
      this.markers = list;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-dialog {
  max-width: 1226px;
  max-height: calc(100vh - 120px);
}

.modal-content {
  max-height: calc(100vh - 120px);
  border: none;
}

.modal-body {
  padding: 0;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
}
</style>
